import React, {useMemo, useEffect, useState, useCallback} from 'react';
import Table from "v4/components/ui/Table/Table";
import {Link} from "react-router-dom";
import {routesBase} from 'v4/data/appRoutes'
import useFetch from "v4/hooks/useFetch";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import apiService from "v4/services/api.service";
import {
    CUSTOM_ACTIONS_SHOW_LIST,
} from "v4/data/apiRoutes";
import {PolIcon} from "components/PolIcon/policon";
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import useNotification from "v4/hooks/useNotification";
import CustomActionsListDelete
    from "v4/pages/admin/CustomActions/components/CustomActionsListDelete/CustomActionsListDelete";
export default function CustomActionsList({customerId}) {
    const {t} = usePolTranslation()
    const {addSuccessNotification, addErrorNotification} = useNotification()
    // Listing
    const [{
        data: loadedCustomActions,
        isLoading: loadedCustomActionsLoading,
        isError: loadedCustomActionsError
    }, fetchCustomActions] = useFetch();
    const [refetch, setRefetch] = useState(0)
    useEffect(() => {
        fetchCustomActions({
            url: apiService.generateUrl(CUSTOM_ACTIONS_SHOW_LIST, {
                sortField: "name",
                sortOrder: "asc",
                customerId: customerId
            }),
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetch])
    const onDeleteSuccess = useCallback(() => {
        addSuccessNotification(t('delete_custom_action_done'))
        setRefetch(c => c + 1)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetch])
    const onDeleteError = useCallback(() => {
        addErrorNotification(t('delete_custom_action_error'))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const hydrateCustomActionRows = useCallback(() => {
        if (!loadedCustomActions?.['hydra:member']) {
            return null
        }
        const rows = JSON.parse(JSON.stringify(loadedCustomActions['hydra:member']))
        return (
            rows.map((item, index) => {
                return {
                    entity: item.entity,
                    name: item.name,
                    position: item.position,
                    actions: (
                        <ul className="datatable__actions">
                            <Link key={index} to={`${routesBase.adminCustomActions}/${item.id}/edit`}>
                                <li className="datatable__actions__item">
                                    <span className="datatable__actions__item__icon">
                                        <PolIcon icon='edit'/>
                                    </span>
                                </li>
                            </Link>
                            <CustomActionsListDelete item={item} onSuccessCallback={onDeleteSuccess}
                                                     onErrorCallBack={onDeleteError}/>
                        </ul>
                    )
                };
            })
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedCustomActions])
    const tableList = useMemo(() => {
        return <Table tableRows={hydrateCustomActionRows()} isLoading={loadedCustomActionsLoading}
                      isError={loadedCustomActionsError}
                      theadData={Object.keys({entity: 'entity', name: 'name', position: 'position', actions: 'actions'})}/>
    }, [hydrateCustomActionRows, loadedCustomActionsLoading, loadedCustomActionsError])
    const CardHeaderTools = () => (
        <Link to={`${routesBase.adminCustomActions}/add`}
              className="btn btn-primary">{t('add_new_custom_action')}</Link>
    )
    return (
        <AdminCard title={t('manage_custom_actions')} CardHeaderTools={CardHeaderTools}>
            {tableList}
        </AdminCard>
    )
}